import { Register } from "../components/industry-conversion/Register";
import { SpaceBetween } from "@cloudscape-design/components-themed";
import { useAuthenticationHook } from "../app/useAuthenticationHook";
import { PERMISSIONS } from "../configs/constants";

/*
業態変換登録
 */
const IndustryConversionRegister = () => {
  //権限制御
  useAuthenticationHook(PERMISSIONS.MASTER_EDIT);

  return (
    <SpaceBetween size="l">
      <Register />
    </SpaceBetween>
  );
};

export default IndustryConversionRegister;
